import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  Heart, 
  Wind, 
  Phone, 
  BookOpen, 
  Headphones, 
  Trophy,
  LucideIcon 
} from 'lucide-react';

interface QuickActionsWidgetProps {
  config: Record<string, unknown>;
  data?: unknown;
  onAction?: (actionType: string) => void;
}

interface ActionConfig {
  id: string;
  label: string;
  icon: string;
  action: string;
  variant?: 'default' | 'secondary' | 'outline' | 'ghost';
}

const ICON_MAP: Record<string, LucideIcon> = {
  heart: Heart,
  wind: Wind,
  phone: Phone,
  book: BookOpen,
  headphones: Headphones,
  trophy: Trophy,
};

const DEFAULT_ACTIONS: ActionConfig[] = [
  { id: 'breathe', label: 'Breathe', icon: 'wind', action: 'breathe', variant: 'secondary' },
  { id: 'sos', label: 'SOS', icon: 'phone', action: 'sos', variant: 'default' },
  { id: 'read', label: 'Read', icon: 'book', action: 'read', variant: 'outline' },
  { id: 'listen', label: 'Listen', icon: 'headphones', action: 'listen', variant: 'outline' },
];

export function QuickActionsWidget({ config, onAction }: QuickActionsWidgetProps) {
  const title = (config.title as string) || 'Quick Actions';
  const actions = (config.actions as ActionConfig[]) || DEFAULT_ACTIONS;
  const columns = (config.columns as number) || 2;

  const handleAction = (action: string) => {
    onAction?.(action);
  };

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div 
          className="grid gap-2"
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
        >
          {actions.map((action) => {
            const Icon = ICON_MAP[action.icon] || Heart;
            return (
              <Button
                key={action.id}
                variant={action.variant || 'outline'}
                className="h-auto py-3 flex-col gap-1"
                onClick={() => handleAction(action.action)}
              >
                <Icon className="h-5 w-5" />
                <span className="text-xs">{action.label}</span>
              </Button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
